module.exports = __webpack_public_path__ + "static/media/sticker-bc2023-view.17ce997d.jpg";